<template>
    <div class="orgstructure-content">
        <local-tree-view
            ref="treeViewRef"
            :data-source="departmentList"
            :width="300"
            :meta="meta"
            @item-click="onItemClick"
            class="org-structure-tree-view"
        >
            <template #item="{ data }">
                <div class="flex items-center gap-2">
                    <img :src="data.img_src" />
                    {{data.name}}
                </div>
            </template>
        </local-tree-view>
        <div class="orgstructure-card">
                <component :is="componentCardName" ref="cardRef" />
        </div>
    </div>
</template>

<script>
export default {
    name: 'org-structure-tree',
};
</script>

<script setup>
import { /*computed,*/ ref, onMounted/*, nextTick*/ } from 'vue';
import localTreeView from '@/components/local-tree-view.vue';
//import { getCookie, setCookie } from '@/utils/cookies';
//import { getDepartmentsStartList } from '@/service/admin-service';
import { getNsiOrgstructureTreeviewData } from '@/service/nsi-service';
import router from '@/router';

const treeViewRef = ref();
const treeViewInstance = ref();
const departmentList = ref([]);
//const formData = inject('formData');
//const selectedDeps = ref(new Map());
const componentCardName = ref(null);
const cardRef = ref();

//const cardName = computed(() => componentCardName.value);

onMounted(async () => {

    treeViewInstance.value = treeViewRef.value?.treeViewInstance;


    const nodes = await getNsiOrgstructureTreeviewData();
    nodes.forEach(node => {if (node.e === 'KR_ORG')
                             node.img_src = '/infoenergo/assets/department.svg';
                           else if (node.e === 'KR_EMPLOYEE')
                             node.img_src = '/infoenergo/assets/person.svg'; });
    departmentList.value = nodes; // await getNsiOrgstructureTreeviewData();
});

window.onblur = function () {
    if (treeViewRef.value) treeViewInstance.value?.option('focusedElement', '');
};

const onItemClick = event => {
    //const currentLogin = getCookie('login');
    //formData.depId = event.itemData.dep_id;

    //selectedDeps.value.set(currentLogin, formData.depId);
    //setCookie('selectedDep', JSON.stringify(Array.from(selectedDeps.value.entries())));

    //console.log('onItemClick event.itemData', event.itemData);

    if (event.itemData.e === 'KR_ORG') {
        componentCardName.value = null;
        setTimeout( async() => {
            await router.push({
                name: 'org-structure-org',
                params: {
                    app: router.currentRoute.value.params.app,
                    dep: router.currentRoute.value.params.dep,
                    id: event.itemData.id
                },
            });
            componentCardName.value = 'nsi-org-card';
        }, 500);
    }
    else if (event.itemData.e === 'KR_EMPLOYEE') {
        componentCardName.value = null;
        setTimeout( async() => {
            await router.push({
                name: 'org-structure-emp',
                params: {
                    app: router.currentRoute.value.params.app,
                    dep: router.currentRoute.value.params.dep,
                    id: event.itemData.id
                },
            });
            componentCardName.value = 'nsi-emp-card';
        }, 500);
    }
};

const meta = {
    searchHint: null,
    keyExpr: 'id_t',
    displayExpr: 'name',
    parentIdExpr: 'parent_id_t',
    dataStructure: 'plain',
    rootValue: null,
    selectByClick: true,
    selectionMode: 'single',
    expandEvent: 'dbclick',
    itemTemplate: 'item',
    valueChangeEvent: 'keyup',
    animationEnabled: false,
    expandAll: true,
};
</script>
<style>
 .orgstructure-content {
     display: flex;
     flex-direction: row;
     height: 100%;
     width: 100%;
     overflow: hidden;
     padding: 5px 5px 0 5px;
 }

 orgstructure-card {
     display: contents;
     height: 100%;
     width: 100%;
     position: relative;
 }


</style>
